import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseState = state => state.modals.company.disassociate;

export const shouldShowDisassociateModal = createSelector([baseState], (state) => {
    return state.show && !!state.companyId;
});
export const disassociateModalError = createSelector([baseState], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    }
});
export const disassociateModalLoading = createSelector([baseState], (state) => {
    return state.status === ReducerStatuses.LOADING;
});
export const disassociateCompanyId = createSelector([baseState], (state) => {
    return state.companyId;
});